<app-header></app-header>
<!-- Middle Content CSS End Here  -->
<div class="middle-content-wrap">
    <!-- Dashboard HTML Start Here  -->
    <div class="globalheading dflex dflex_bet">
        <h2>
            <span routerLink="/group-dates" class="breadcumbs">Group Dates</span> <span
                class="navigation-arrow">></span>
            <span>Attendees</span>
        </h2>
    </div>
    <div class="customer-detial-view">
        <div class="row">
            <div class="col-md-12">
                <div class="user-detail-card" style="min-height: 100%;">
                    <div class="dflex dflex_bet flex-wrap">
                        <div class="user-card-left flex-1">
                            <div class="d-flex username_div">
                                <p>{{ groupDate?.title}}</p>
                            </div>

                            <div class="userextrainfo">
                                <ul>
                                    <li>
                                        <span>Date: </span>
                                        <span>{{ groupDate?.slot_date | date:'mediumDate' }}, {{ groupDate?.slot_time
                                            }}</span>
                                    </li>
                                    <ng-container
                                        *ngIf="groupDate?.status === 'Open' || groupDate?.status === 'Upcoming'">
                                        <li>
                                            <span>Slot Opens at: </span>
                                            <span>{{groupDate?.slot_opens_at | date: 'mediumDate':'+0400'}},
                                                {{groupDate?.slot_opens_at | date: 'shortTime':'+0400'}}</span>
                                        </li>
                                        <li>
                                            <span>Slot Closes After: </span>
                                            <span>{{groupDate?.slot_closes_after}} hours</span>
                                        </li>
                                    </ng-container>
                                    <li>
                                        <span>Address: </span>
                                        <span>{{ groupDate?.venue_name }} , {{groupDate?.address}}</span>
                                    </li>
                                    <li>
                                        <span>Maximum Participants: </span>
                                        <span>{{ groupDate?.max_participants }}</span>
                                    </li>
                                    <li>
                                        <span>Maximum Participants Limit: </span>
                                        <span>{{ groupDate?.max_participants_limit }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="user-card-right gap-2 flex-1 d-flex flex-column align-items-center justify-content-center mt-2">
                            <button [disabled]="getCurrentStep() != 1" class="btn btn-primary ml-3"
                                (click)="confirmInvites()" [ngClass]="{'btn-disabled': getCurrentStep() != 1}">
                                <i class="fas fa-spinner fa-spin" *ngIf="isConfirmingInvites"></i>
                                {{ isConfirmingInvites ? 'Sending...' : 'Confirm Invites' }}
                            </button>
                            <button [disabled]="getCurrentStep() != 2" class="btn btn-primary ml-3"
                                (click)="openGroupDate()" [ngClass]="{'btn-disabled': getCurrentStep() != 2}">
                                <i class="fas fa-spinner fa-spin" *ngIf="isOpeningGroupDate"></i>
                                {{ isOpeningGroupDate ? 'Opening...' : 'Open Group Date' }}
                            </button>
                            <button [disabled]="getCurrentStep() != 3" class="btn btn-primary ml-3"
                                (click)="closeGroupDate()" [ngClass]="{'btn-disabled': getCurrentStep() != 3}">
                                <i class="fas fa-spinner fa-spin" *ngIf="isClosingGroupDate"></i>
                                {{ isClosingGroupDate ? 'Closing...' : 'Close Group Date' }}
                            </button>
                            <button [disabled]="getCurrentStep() != 4" class="btn btn-primary ml-3"
                                (click)="confirmGroupDate()" [ngClass]="{'btn-disabled': getCurrentStep() != 4}">
                                <i class="fas fa-spinner fa-spin" *ngIf="isConfirmingGroupDate"></i>
                                {{ isConfirmingGroupDate ? 'Confirming...' : 'Confirm Group Date' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="basic-detail-view">
            <div class="row">
                <div class="col-md-12">
                    <!-- Confirmed Attendees Card -->
                    <div *ngIf="groupDate?.status === 'Closed' || groupDate?.status === 'Completed' || groupDate?.status === 'Confirmed'"
                        class="user-detail-card user-detail-view-card mb-4">
                        <span>Confirmed Attendees ({{ getConfirmedAttendeesCount() + getCancelledAttendeesCount()
                            }})</span>
                        <div class="listingformat">
                            <!-- Status Tabs -->
                            <div class="row pt-3">
                                <div class="col-12 col-md-6 mb-2 mb-md-0 px-2 px-md-0"
                                    (click)="selectConfirmedTab('Confirmed')">
                                    <button type="button" class="add-user-btn tab_btn w-100"
                                        [ngClass]="(activeConfirmedTab=='Confirmed')? 'btn_active':''">Confirmed
                                        Attendees ({{ getConfirmedAttendeesCount() }})</button>
                                </div>
                                <div class="col-12 col-md-6 px-2 px-md-0" (click)="selectConfirmedTab('Cancelled')">
                                    <button type="button" class="add-user-btn tab_btn w-100"
                                        [ngClass]="(activeConfirmedTab=='Cancelled')? 'btn_active':''">Cancelled
                                        Attendees ({{ getCancelledAttendeesCount() }})</button>
                                </div>
                            </div>

                            <!-- Confirmed/Cancelled Attendees Table -->
                            <div *ngIf="activeConfirmedTab === 'Confirmed' || activeConfirmedTab === 'Cancelled'"
                                class="mt-4">
                                <div class="tabledatawrap table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Id</th>
                                                <th>User Info</th>
                                                <th>Dates Info</th>
                                                <th>Habits</th>
                                                <th>Deal Breakers</th>
                                                <th>Hobbies</th>
                                                <th>Action</th>
                                                <th *ngIf="activeConfirmedTab === 'Confirmed'">Feedback</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="let attendee of activeConfirmedTab === 'Confirmed' ? confirmedAttendees : cancelledAttendees; let i = index">
                                                <td>
                                                    <div> ({{attendee.info.gender}})</div>
                                                    <div *ngIf="activeConfirmedTab === 'Confirmed'">
                                                        {{attendee.has_confirmed == '1' ? 'Confirmed' : 'YetToConfirm'}}
                                                    </div>
                                                </td>
                                                <!-- ID, Email, Phone, Account Created -->
                                                <td>
                                                    <button type="button" class="btnActive"
                                                        *ngIf="attendee?.info?.isScouted"
                                                        style="background-color: #76f16c66; color: #02b708; margin-left:-1px">Scouted</button>
                                                    <div>ID: {{ attendee.user_id }}</div>
                                                    <div>{{ attendee.info.email }}</div>
                                                    <div>{{ attendee.info.phone }}</div>
                                                    <div>{{ attendee.user_created_at | date:'mediumDate' }}</div>
                                                </td>
                                                <!-- Name, Membership, Joined on -->
                                                <td>
                                                    <div>{{ attendee.info.name }} ({{attendee.info.age}})</div>
                                                    <div>{{ attendee.info.occupation }}</div>
                                                    <div>{{ attendee.info.activeSubscriptionName }} <button
                                                            type="button" class="btnActive"
                                                            *ngIf="selectedUser?.info?.isScouted"
                                                            style="background-color: #76f16c66; color: #02b708;margin-left: 10px;">Scouted</button>
                                                    </div>
                                                    <div>{{ attendee.info.purchaseDate | date:'mediumDate' }}</div>

                                                </td>
                                                <!-- Dates Info -->
                                                <td>
                                                    <div>Planned: {{attendee.info.totalDatesPlanned}}</div>
                                                    <div>Completed: {{attendee.info.totalDatesCompleted}}</div>
                                                    <div>Total Matches: {{attendee.info.totalMatches}}</div>
                                                    <div>Days to First Match: {{attendee.info.daysToFirstMatch}}</div>
                                                </td>
                                                <!-- Habits -->
                                                <td>
                                                    <div>Fitness: {{attendee.info.habits.fitness}}</div>
                                                    <div>Alcohol: {{attendee.info.habits.alcohol_consumption}}</div>
                                                    <div>Smoking: {{attendee.info.habits.smoking}}</div>
                                                    <div>{{attendee.info.habits.wake_up_time}}</div>
                                                </td>
                                                <!-- Deal Breakers -->
                                                <td>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.ageRange.min && attendee.info.dealbreakers.ageRange.max">
                                                        Age:
                                                        {{attendee.info.dealbreakers.ageRange.min}}-{{attendee.info.dealbreakers.ageRange.max}}
                                                    </div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.religions && attendee.info.dealbreakers.religions.length > 0">
                                                        Religion: {{attendee.info.dealbreakers.religions.join(', ')}}
                                                    </div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.fitnessLevels && attendee.info.dealbreakers.fitnessLevels.length > 0">
                                                        Fitness: {{attendee.info.dealbreakers.fitnessLevels.join(', ')}}
                                                    </div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.alcoholPreferences && attendee.info.dealbreakers.alcoholPreferences.length > 0">
                                                        Alcohol: {{attendee.info.dealbreakers.alcoholPreferences.join(',
                                                        ')}}
                                                    </div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.smokingPreferences && attendee.info.dealbreakers.smokingPreferences.length > 0">
                                                        Smoking: {{attendee.info.dealbreakers.smokingPreferences.join(',
                                                        ')}}
                                                    </div>
                                                </td>
                                                <!-- Hobbies -->
                                                <td>
                                                    <div *ngFor="let hobby of attendee.info.hobbies | slice:0:4">{{
                                                        hobby }}</div>
                                                </td>
                                                <!-- Action Buttons -->
                                                <td>
                                                    <div class="action-btns hide-profile-btn"
                                                        style="white-space: nowrap;">
                                                        <button
                                                            (click)="openUserDetailsModal(attendee, activeConfirmedTab)">
                                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <!-- Feedback -->
                                                <td *ngIf="activeConfirmedTab === 'Confirmed'">
                                                    <div *ngIf="attendee.feedback_status == '1'">Attended</div>
                                                    <div *ngIf="attendee.feedback_status == '0'">Not Attended</div>
                                                    <div
                                                        *ngIf="!attendee.feedback_status && attendee.feedback_status != '0'">
                                                        No feedback</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody
                                            *ngIf="(activeConfirmedTab === 'Confirmed' && confirmedAttendees?.length === 0) || (activeConfirmedTab === 'Cancelled' && cancelledAttendees?.length === 0)">
                                            <tr>
                                                <td colspan="8">No {{ activeConfirmedTab }} Attendees Found</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Invited Users Card -->
                    <div class="user-detail-card mb-4">
                        <span class="mb-2">Invited Users ({{ getInvitedAttendeesCount() }})</span>
                        <div>
                            <!-- Search and Filter Section -->
                            <div class="globalheading dflex dflex_bet mb-3">
                                <div class="addbtnhead">
                                    <div class="page-header-right">
                                        <div class="search-wrap">
                                            <input class="form-control" placeholder="Search Users" type="text"
                                                id="searchUsers" (keyup)="onKeyUpEvent($event)" />
                                            <i class="fas fa-search"></i>
                                        </div>
                                        <div class="common_btn">
                                            <button class="filter-btn" (click)="toggleFilters()">
                                                <i class="fas fa-filter"></i> Filters
                                                <span *ngIf="activeFilterChips.length > 0"
                                                    class="filter-badge">{{activeFilterChips.length}}</span>
                                            </button>
                                        </div>
                                        <!-- Gender Filter Toggle -->
                                        <div class="gender-filter-container">
                                            <label class="gender-filter-label">Gender:</label>
                                            <div class="gender-toggle">
                                                <button class="gender-btn" [class.active]="selectedGender === 'Male'"
                                                    (click)="setGenderFilter('Male')">
                                                    <i class="fas fa-mars"></i> Male
                                                </button>
                                                <button class="gender-btn" [class.active]="selectedGender === 'Female'"
                                                    (click)="setGenderFilter('Female')">
                                                    <i class="fas fa-venus"></i> Female
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Shared Filter Component -->
                            <app-filter [showFilters]="showFilters" [activeFilterSection]="activeFilterSection"
                                [selectedFilters]="selectedFilters" [activeFilterChips]="activeFilterChips"
                                [showNumberOfLikes]="false" [religionOptions]="religionOptions"
                                [nationalityOptions]="nationalityOptions" [maritalStatusOptions]="maritalStatusOptions"
                                [genderOptions]="genderOptions" [interestOptions]="interestOptions"
                                [valueOptions]="valueOptions" [alcoholConsumptionOptions]="alcoholConsumptionOptions"
                                [smokingOptions]="smokingOptions" [childrenOptions]="childrenOptions"
                                [wakeupAtOptions]="wakeupAtOptions" [hobbiesOptions]="hobbiesOptions"
                                [fitnessOptions]="fitnessOptions" [personalityOptions]="personalityOptions"
                                [lifeGoalsOptions]="lifeGoalsOptions" [maxionGoalsOptions]="maxionGoalsOptions"
                                [meetVibesOptions]="meetVibesOptions"
                                [subscriptionStatusOptions]="subscriptionStatusOptions"
                                (toggleFilters)="toggleFilters()" (toggleFilterSection)="toggleFilterSection($event)"
                                (updateSingleSelect)="updateSingleSelect($event)"
                                (updateMultiSelect)="updateMultiSelect($event)"
                                (applyAgeRangeFilter)="applyAgeRangeFilter($event)"
                                (applyStepRangeFilter)="applyStepRangeFilter($event)"
                                (updateNumberInput)="updateNumberInput($event)" (applyFilters)="applyFilters()"
                                (clearFilterChip)="clearFilterChip($event)" (clearAllFilters)="clearAllFilters()">
                            </app-filter>

                            <!-- Search Results Section -->
                            <div *ngIf="search || searchResults.length > 0 || searchLoading"
                                class="search-results-section mb-4">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h4>Search Results - Invite Users to Date ({{ searchCount }})</h4>
                                    <div class="d-flex gap-2">
                                        <button *ngIf="searchResults.length > 0" class="btn btn-outline-secondary"
                                            (click)="selectAllUsers()">
                                            Select All
                                        </button>
                                        <button *ngIf="selectedUsers.length > 0" class="btn btn-outline-danger"
                                            (click)="deselectAllUsers()">
                                            Deselect All
                                        </button>
                                        <button *ngIf="selectedUsers.length > 0" class="btn btn-primary"
                                            (click)="addSelectedUsersToWaitlist()">
                                            Invite {{ selectedUsers.length }} Selected User(s) to Date
                                        </button>
                                        <button class="btn btn-outline-secondary" (click)="closeSearchResults()">
                                            <i class="fas fa-times"></i> Close
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="searchCount > 0 || (search && !searchLoading)" class="search-summary mb-3">
                                    <span class="text-muted" *ngIf="searchCount > 0">Found {{ searchCount }} user(s)
                                        matching your criteria</span>
                                    <span class="text-muted" *ngIf="searchCount === 0 && search && !searchLoading">No
                                        users found matching your criteria</span>
                                </div>
                                <div class="tabledatawrap table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Select</th>
                                                <th>ID</th>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Age</th>
                                                <th>Gender</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let user of searchResults">
                                                <td>
                                                    <input type="checkbox" [checked]="isUserSelected(user.id)"
                                                        [disabled]="!canSelectUser(user.id)"
                                                        (change)="toggleUserSelection(user.id)">
                                                </td>
                                                <td>{{ user.id }}</td>
                                                <td>{{ user.name || 'N/A' }}</td>
                                                <td>{{ user.email || 'N/A' }}</td>
                                                <td>{{ user.phone || 'N/A' }}</td>
                                                <td>{{ user.age || 'N/A' }}</td>
                                                <td>{{ user.gender || 'N/A' }}</td>
                                                <td>
                                                    <div class="action-btns">
                                                        <button class="btn btn-sm btn-outline-secondary me-2"
                                                            (click)="openUserDetailsModal(user, 'search')">
                                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                                        </button>
                                                        <!-- Invite to Date - for users not in any list -->
                                                        <button
                                                            *ngIf="!isUserInWaitlist(user.id) && !getUserStatus(user.id) && !isUserInvited(user.id)"
                                                            class="btn btn-sm btn-primary"
                                                            (click)="inviteUserToDate(user, user.gender)">
                                                            Invite to Date
                                                        </button>
                                                        <!-- Confirmed - non-clickable -->
                                                        <button *ngIf="getUserStatus(user.id) === 'Confirmed'"
                                                            class="btn btn-sm btn-success" disabled>
                                                            Confirmed
                                                        </button>
                                                        <!-- Cancelled and Waitlist with if-else logic -->
                                                        <ng-container
                                                            *ngIf="getUserStatus(user.id) === 'Cancelled'; else checkWaitlist">
                                                            <button class="btn btn-sm btn-warning" disabled>
                                                                Cancelled
                                                            </button>
                                                        </ng-container>

                                                        <ng-template #checkWaitlist>
                                                            <button *ngIf="isUserInWaitlist(user.id)"
                                                                class="btn btn-sm btn-info" disabled>
                                                                In Waitlist
                                                            </button>
                                                        </ng-template>
                                                        <!-- Remove from Invited - for invited users -->
                                                        <button *ngIf="isUserInvited(user.id)"
                                                            class="btn btn-sm btn-danger"
                                                            (click)="removeInvitedUserFromSearch(user)">
                                                            Remove Invite
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody *ngIf="searchResults.length === 0 && !searchLoading">
                                            <tr>
                                                <td colspan="8">
                                                    <div class="text-center py-4">
                                                        <i class="fas fa-search"
                                                            style="font-size: 2rem; color: #6c757d; margin-bottom: 10px;"></i>
                                                        <p class="text-muted mb-0">No users found matching your search
                                                            criteria</p>
                                                        <small class="text-muted">Try adjusting your search terms or
                                                            filters</small>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div *ngIf="searchLoading" class="text-center">
                                    <p>Loading search results...</p>
                                </div>

                                <!-- Pagination Controls -->
                                <div *ngIf="searchCount > 0 && searchTotalPages > 1" class="pagination-container mt-3">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="pagination-info">
                                            <span>{{ getPaginationInfo() }}</span>
                                        </div>
                                        <div class="pagination-controls">
                                            <nav aria-label="Search results pagination">
                                                <ul class="pagination pagination-sm mb-0">
                                                    <!-- Previous Page -->
                                                    <li class="page-item" [class.disabled]="!searchHasPrevPage">
                                                        <button class="page-link" (click)="prevPage()"
                                                            [disabled]="!searchHasPrevPage">
                                                            <i class="fas fa-chevron-left"></i>
                                                        </button>
                                                    </li>

                                                    <!-- First Page -->
                                                    <li *ngIf="searchPage > 3" class="page-item">
                                                        <button class="page-link" (click)="goToPage(1)">1</button>
                                                    </li>

                                                    <!-- Ellipsis -->
                                                    <li *ngIf="searchPage > 4" class="page-item disabled">
                                                        <span class="page-link">...</span>
                                                    </li>

                                                    <!-- Page Numbers -->
                                                    <li *ngFor="let page of getPageNumbers()" class="page-item"
                                                        [class.active]="page === searchPage">
                                                        <button class="page-link" (click)="goToPage(page)">{{ page
                                                            }}</button>
                                                    </li>

                                                    <!-- Ellipsis -->
                                                    <li *ngIf="searchPage < searchTotalPages - 3"
                                                        class="page-item disabled">
                                                        <span class="page-link">...</span>
                                                    </li>

                                                    <!-- Last Page -->
                                                    <li *ngIf="searchPage < searchTotalPages - 2" class="page-item">
                                                        <button class="page-link"
                                                            (click)="goToPage(searchTotalPages)">{{ searchTotalPages
                                                            }}</button>
                                                    </li>

                                                    <!-- Next Page -->
                                                    <li class="page-item" [class.disabled]="!searchHasNextPage">
                                                        <button class="page-link" (click)="nextPage()"
                                                            [disabled]="!searchHasNextPage">
                                                            <i class="fas fa-chevron-right"></i>
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Invited Attendees List Section -->
                            <div class="invited-attendees-section mt-4">
                                <!-- Gender Tabs for Invited Users -->
                                <div class="row pt-3">
                                    <div class="col-12 col-md-6 mb-2 mb-md-0 px-2 px-md-0"
                                        (click)="selectInvitedTab('Male')">
                                        <button type="button" class="add-user-btn tab_btn w-100"
                                            [ngClass]="(activeInvitedTab=='Male')? 'btn_active':''">Male
                                            Invited ({{ getMaleInvitedAttendeesCount() }})</button>
                                    </div>
                                    <div class="col-12 col-md-6 px-2 px-md-0" (click)="selectInvitedTab('Female')">
                                        <button type="button" class="add-user-btn tab_btn w-100"
                                            [ngClass]="(activeInvitedTab=='Female')? 'btn_active':''">Female
                                            Invited ({{ getFemaleInvitedAttendeesCount() }})</button>
                                    </div>
                                </div>

                                <!-- Invited Attendees Table -->
                                <div *ngIf="activeInvitedTab === 'Male' || activeInvitedTab === 'Female'" class="mt-4">
                                    <div class="tabledatawrap table-responsive">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Id</th>
                                                    <th>User Info</th>
                                                    <th>Dates Info</th>
                                                    <th>Habits</th>
                                                    <th>Deal Breakers</th>
                                                    <th>Hobbies</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let attendee of getCurrentInvitedAttendeesList(); let i = index">
                                                    <td>{{i + 1}}</td>
                                                    <!-- ID, Email, Phone, Account Created -->
                                                    <td>
                                                        <button type="button" class="btnActive"
                                                            *ngIf="attendee?.info?.isScouted"
                                                            style="background-color: #76f16c66; color: #02b708; margin-left:-1px">Scouted</button>
                                                        <div>ID: {{ attendee.user_id }}</div>
                                                        <div>{{ attendee.info.email }}</div>
                                                        <div>{{ attendee.info.phone }}</div>
                                                        <div>{{ attendee.user_created_at | date:'mediumDate' }}</div>
                                                    </td>
                                                    <!-- Name, Membership, Joined on -->
                                                    <td>
                                                        <div>{{ attendee.info.name }} ({{attendee.info.age}})</div>
                                                        <div>{{ attendee.info.occupation }}</div>
                                                        <div>{{ attendee.info.activeSubscriptionName }}</div>
                                                        <div>{{ attendee.info.purchaseDate | date:'mediumDate' }}</div>
                                                    </td>
                                                    <!-- Dates Info -->
                                                    <td>
                                                        <div>Planned: {{attendee.info.totalDatesPlanned}}</div>
                                                        <div>Completed: {{attendee.info.totalDatesCompleted}}</div>
                                                        <div>Cancelled: {{attendee.info.totalDatesCancelled}}</div>
                                                        <div>Likes Sent: {{attendee.info.totalLikesSent}}</div>
                                                        <div>Likes Received: {{attendee.info.totalLikesReceived}}</div>
                                                        <div>Total Matches: {{attendee.info.totalMatches}}</div>
                                                        <div>Days to First Match: {{attendee.info.daysToFirstMatch}}
                                                        </div>
                                                    </td>
                                                    <!-- Habits -->
                                                    <td>
                                                        <div>Fitness: {{attendee.info.habits.fitness}}</div>
                                                        <div>Alcohol: {{attendee.info.habits.alcohol_consumption}}</div>
                                                        <div>Smoking: {{attendee.info.habits.smoking}}</div>
                                                        <div>{{attendee.info.habits.wake_up_time}}</div>
                                                    </td>
                                                    <!-- Deal Breakers -->
                                                    <td>
                                                        <div
                                                            *ngIf="attendee.info.dealbreakers.ageRange.min && attendee.info.dealbreakers.ageRange.max">
                                                            Age:
                                                            {{attendee.info.dealbreakers.ageRange.min}}-{{attendee.info.dealbreakers.ageRange.max}}
                                                        </div>
                                                        <div
                                                            *ngIf="attendee.info.dealbreakers.religions && attendee.info.dealbreakers.religions.length > 0">
                                                            Religion: {{attendee.info.dealbreakers.religions.join(',
                                                            ')}}
                                                        </div>
                                                        <div
                                                            *ngIf="attendee.info.dealbreakers.fitnessLevels && attendee.info.dealbreakers.fitnessLevels.length > 0">
                                                            Fitness: {{attendee.info.dealbreakers.fitnessLevels.join(',
                                                            ')}}
                                                        </div>
                                                        <div
                                                            *ngIf="attendee.info.dealbreakers.alcoholPreferences && attendee.info.dealbreakers.alcoholPreferences.length > 0">
                                                            Alcohol:
                                                            {{attendee.info.dealbreakers.alcoholPreferences.join(',
                                                            ')}}
                                                        </div>
                                                        <div
                                                            *ngIf="attendee.info.dealbreakers.smokingPreferences && attendee.info.dealbreakers.smokingPreferences.length > 0">
                                                            Smoking:
                                                            {{attendee.info.dealbreakers.smokingPreferences.join(',
                                                            ')}}
                                                        </div>
                                                    </td>
                                                    <!-- Hobbies -->
                                                    <td>
                                                        <div *ngFor="let hobby of attendee.info.hobbies | slice:0:4">{{
                                                            hobby }}</div>
                                                    </td>
                                                    <!-- Action -->
                                                    <td>
                                                        <div class="action-btns hide-profile-btn"
                                                            style="white-space: nowrap;">
                                                            <button
                                                                (click)="openUserDetailsModal(attendee, 'Invited' + activeInvitedTab)">
                                                                <i class="fa fa-eye" aria-hidden="true"></i>
                                                            </button>
                                                            <button class="btn btn-sm btn-danger ml-2"
                                                                (click)="removeInvitedUser(attendee)">
                                                                Remove
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody *ngIf="getCurrentInvitedAttendeesList().length === 0">
                                                <tr>
                                                    <td colspan="8">
                                                        <div class="text-center py-4">
                                                            <i class="fas fa-users"
                                                                style="font-size: 2rem; color: #6c757d; margin-bottom: 10px;"></i>
                                                            <p class="text-muted mb-0">No {{ activeInvitedTab }} invited
                                                                users found</p>
                                                            <small class="text-muted">Use the search above to invite {{
                                                                activeInvitedTab.toLowerCase() }} users</small>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Existing Waitlisted Card -->
                    <div class="user-detail-card user-detail-view-card">
                        <span>Waitlisted Attendees ({{ getWaitlistedAttendeesCount() }})</span>
                        <div class="listingformat">

                            <!-- Gender Tabs -->
                            <div class="row pt-3">
                                <div class="col-12 col-md-6 mb-2 mb-md-0 px-2 px-md-0" (click)="selectTab('Male')">
                                    <button type="button" class="add-user-btn tab_btn w-100"
                                        [ngClass]="(activeTab=='Male')? 'btn_active':''">Male Attendees ({{
                                        getMaleWaitlistedAttendeesCount() }})</button>
                                </div>
                                <div class="col-12 col-md-6 px-2 px-md-0" (click)="selectTab('Female')">
                                    <button type="button" class="add-user-btn tab_btn w-100"
                                        [ngClass]="(activeTab=='Female')? 'btn_active':''">Female Attendees ({{
                                        getFemaleWaitlistedAttendeesCount() }})</button>
                                </div>
                            </div>

                            <!-- Male Attendees Table -->
                            <div *ngIf="activeTab === 'Male' || activeTab === 'Female'" class="mt-4">
                                <div class="tabledatawrap table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Id</th>
                                                <th>User Info</th>
                                                <th>Dates Info</th>
                                                <th>Habits</th>
                                                <th>Deal Breakers</th>
                                                <th>Hobbies</th>
                                                <th>Order</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                *ngFor="let attendee of activeTab === 'Male' ? maleAttendees : femaleAttendees; let i = index">
                                                <td>{{i + 1}}</td>
                                                <!-- ID, Email, Phone, Account Created -->
                                                <td>
                                                    <button type="button" class="btnActive"
                                                        *ngIf="attendee?.info?.isScouted"
                                                        style="background-color: #76f16c66; color: #02b708; margin-left:-1px">Scouted</button>
                                                    <div>ID: {{ attendee.user_id }}</div>
                                                    <div>{{ attendee.info.email }}</div>
                                                    <div>{{ attendee.info.phone }}</div>
                                                    <div>{{ attendee.user_created_at |
                                                        date:'mediumDate' }}</div>
                                                </td>
                                                <!-- Name, Membership, Joined on -->
                                                <td>
                                                    <div>{{ attendee.info.name }} ({{attendee.info.age}})</div>
                                                    <div>{{ attendee.info.occupation }}</div>
                                                    <div>{{
                                                        attendee.info.activeSubscriptionName }}
                                                    </div>
                                                    <div>{{ attendee.info.purchaseDate | date:'mediumDate' }}</div>
                                                </td>
                                                <!-- Dates Info -->
                                                <td>
                                                    <div>Planned: {{attendee.info.totalDatesPlanned}}</div>
                                                    <div>Completed: {{attendee.info.totalDatesCompleted}}</div>
                                                    <div>Cancelled: {{attendee.info.totalDatesCancelled}}</div>
                                                    <div>Likes Sent: {{attendee.info.totalLikesSent}}</div>
                                                    <div>Likes Received: {{attendee.info.totalLikesReceived}}</div>
                                                    <div>Total Matches: {{attendee.info.totalMatches}}</div>
                                                    <div>Days to First Match: {{attendee.info.daysToFirstMatch}}</div>
                                                </td>
                                                <!-- Habits -->
                                                <td>
                                                    <div>Fitness: {{attendee.info.habits.fitness}}
                                                    </div>
                                                    <div>Alcohol:
                                                        {{attendee.info.habits.alcohol_consumption}}</div>
                                                    <div>Smoking:
                                                        {{attendee.info.habits.smoking}}</div>
                                                    <div>{{attendee.info.habits.wake_up_time}}</div>
                                                </td>
                                                <!-- Deal Breakers -->
                                                <td>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.ageRange.min && attendee.info.dealbreakers.ageRange.max">
                                                        Age:
                                                        {{attendee.info.dealbreakers.ageRange.min}}-{{attendee.info.dealbreakers.ageRange.max}}
                                                    </div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.religions && attendee.info.dealbreakers.religions.length > 0">
                                                        Religion:
                                                        {{attendee.info.dealbreakers.religions.join(', ')}}</div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.fitnessLevels && attendee.info.dealbreakers.fitnessLevels.length > 0">
                                                        Fitness:
                                                        {{attendee.info.dealbreakers.fitnessLevels.join(', ')}}
                                                    </div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.alcoholPreferences && attendee.info.dealbreakers.alcoholPreferences.length > 0">
                                                        Alcohol:
                                                        {{attendee.info.dealbreakers.alcoholPreferences.join(', ')}}
                                                    </div>
                                                    <div
                                                        *ngIf="attendee.info.dealbreakers.smokingPreferences && attendee.info.dealbreakers.smokingPreferences.length > 0">
                                                        Smoking:
                                                        {{attendee.info.dealbreakers.smokingPreferences.join(', ')}}
                                                    </div>
                                                </td>
                                                <!-- Hobbies -->
                                                <td>
                                                    <div *ngFor="let hobby of attendee.info.hobbies | slice:0:4">{{
                                                        hobby }}</div>
                                                </td>
                                                <!-- Order -->
                                                <td>
                                                    <div class="action-btns">
                                                        <input type="number" [(ngModel)]="attendee.sort_order"
                                                            class="form-control" placeholder="Order" min="1"
                                                            style="width: 60px;">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="action-btns hide-profile-btn"
                                                        style="white-space: nowrap;">
                                                        <button (click)="openUserDetailsModal(attendee, activeTab)">
                                                            <i class="fa fa-eye" aria-hidden="true"></i>
                                                        </button>
                                                        <button (click)="openRemoveAttendeeModal(attendee)"
                                                            style="margin-left: 8px;">
                                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody
                                            *ngIf="activeTab === 'Male' && maleAttendees?.length==0 || activeTab === 'Female' && femaleAttendees?.length==0">
                                            <tr>
                                                <td colspan="6">No {{ activeTab }} Attendees Found</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="text-right mt-3">
                                    <button class="btn btn-primary" [disabled]="isSavingOrder"
                                        (click)="saveAttendeeOrder(activeTab)">
                                        Save {{ activeTab }} Order
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Middle Content CSS End Here  -->

<!-- Remove Attendee Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="removeAttendeeModal" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Remove Attendee
                </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <p> Are you sure you want to remove this attendee?</p>
                    <div class="common_btn">
                        <button data-dismiss="modal">Cancel</button>
                        <button (click)="removeAttendee()" id="closeM">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Confirm Group Date Modal -->
<div class="modal fade bd-example-modal-sm common_modal" id="confirmGroupDateModal" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    Confirm Group Date
                </div> <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <p>Are you sure you want to confirm this group date? This will finalize the attendees and cannot be
                        undone.</p>
                    <div class="common_btn">
                        <button data-dismiss="modal">Cancel</button>
                        <button (click)="confirmGroupDate()" id="closeM">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- User Details Modal -->
<div class="modal fade bd-example-modal-lg common_modal" id="userDetailsModal" tabindex="-1" role="dialog"
    aria-labelledby="userDetailsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg animated fadeInDown">
        <div class="modal-content">
            <div class="modal-header">
                <div class="popupheding">
                    User Details
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
                <div class="filtercard">
                    <div class="user-details-navigation d-flex justify-content-between align-items-center"
                        *ngIf="totalUsers > 1">
                        <button class="btn btn-secondary" (click)="navigateUser('prev')"
                            [disabled]="!canNavigatePrev()">
                            <i class="fa fa-arrow-left"></i> Previous
                        </button>
                        <span class="current-position mx-4">{{currentUserIndex + 1}} of {{totalUsers}}</span>
                        <button class="btn btn-secondary" (click)="navigateUser('next')"
                            [disabled]="!canNavigateNext()">
                            Next <i class="fa fa-arrow-right"></i>
                        </button>
                    </div>

                    <!-- User Detail Navigation (same as customer-detail) - Only for Search Users -->
                    <div class="user-details-navigation d-flex justify-content-between align-items-center"
                        *ngIf="userDetailData && isSearchUser">
                        <button class="btn btn-secondary" (click)="moveToPrevUser()" [disabled]="!prev_user_id">
                            <i class="fa fa-arrow-left"></i> Previous User
                        </button>
                        <span class="current-position mx-4">User ID: {{selectedUser?.user_id ||
                            selectedUser?.id}}</span>
                        <button class="btn btn-secondary" (click)="moveToNextUser()" [disabled]="!next_user_id">
                            Next User <i class="fa fa-arrow-right"></i>
                        </button>
                    </div>

                    <div class="user-details-content mt-4">
                        <!-- Profile Header -->
                        <div class="row">
                            <div class="col-md-12">
                                <div class="details-section text-center">
                                    <div class="user-img-wrap"
                                        *ngIf="profileStatus?.selfieImage == null || profileStatus?.selfieImage == ''; else profile">
                                        <img src="assets/images/userimg.png" class="profile-image-large mb-3" />
                                    </div>
                                    <ng-template #profile>
                                        <div class="user-img-wrap">
                                            <img [src]="profileStatus?.selfieImage" class="profile-image-large mb-3" />
                                        </div>
                                    </ng-template>

                                    <h4>{{personalDetails?.name || 'N/A'}}
                                        <button type="button" class="btnActive" *ngIf="selectedUser?.info?.isScouted"
                                            style="background-color: #76f16c66; color: #02b708;">Scouted</button>
                                    </h4>

                                    <div *ngIf="isConfirmedModalOpen && activeConfirmedTab === 'Confirmed'"
                                        class="confirmation-status mt-2">
                                        <span class="badge"
                                            [ngClass]="{'badge-success': selectedUser?.has_confirmed == '1', 'badge-warning': selectedUser?.has_confirmed != '1'}">
                                            {{selectedUser?.has_confirmed == '1' ? 'Confirmed' : 'Yet to Confirm'}}
                                        </span>
                                    </div>

                                    <!-- Sort Order for Waitlisted Users -->
                                    <div *ngIf="selectedUser && !isConfirmedModalOpen && !isSearchUser && !isInvitedUser"
                                        class="d-flex justify-content-center align-items-center mt-3">
                                        <input type="number" name="sortOrder" [(ngModel)]="selectedUser.sort_order"
                                            class="form-control" style="width: 80px; margin-right: 10px;" min="1">
                                        <button class="btn btn-primary btn-sm" [disabled]="isSavingOrder"
                                            (click)="saveOrder()">
                                            Save Order
                                        </button>
                                    </div>

                                    <!-- Remove Button for Invited Users -->
                                    <div *ngIf="isInvitedUser"
                                        class="d-flex justify-content-center align-items-center mt-3">
                                        <button class="btn btn-danger btn-sm" (click)="removeInvitedUser(selectedUser)">
                                            <i class="fa fa-trash"></i> Remove
                                        </button>
                                    </div>

                                    <!-- Action Buttons for Search Users -->
                                    <div *ngIf="isSearchUser"
                                        class="d-flex justify-content-center align-items-center mt-3">
                                        <div class="action-buttons">
                                            <button
                                                *ngIf="!isUserInWaitlist(selectedUser?.id) && !getUserStatus(selectedUser?.id) && !isUserInvited(selectedUser?.id)"
                                                class="btn btn-primary btn-sm me-2"
                                                (click)="inviteUserToDate(selectedUser, selectedUser?.gender)">
                                                <i class="fa fa-plus"></i> Invite to Date
                                            </button>
                                            <button
                                                *ngIf="isUserInWaitlist(selectedUser?.id) || isUserInvited(selectedUser?.id)"
                                                class="btn btn-secondary btn-sm me-2"
                                                (click)="removeInvitedUser(selectedUser)">
                                                <i class="fa fa-minus"></i> Remove
                                            </button>
                                            <button *ngIf="getUserStatus(selectedUser?.id) === 'Confirmed'"
                                                class="btn btn-success btn-sm me-2" disabled>
                                                <i class="fa fa-check"></i> Confirmed
                                            </button>
                                            <button *ngIf="getUserStatus(selectedUser?.id) === 'Cancelled'"
                                                class="btn btn-warning btn-sm me-2" disabled>
                                                <i class="fa fa-times"></i> Cancelled
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Basic Information and Dates Info -->
                        <div class="row">
                            <div class="col-md-6">
                                <div class="details-section">
                                    <h5>Personal Details</h5>
                                    <div class="detail-item">
                                        <label>Name:</label>
                                        <span>{{personalDetails?.name || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Email:</label>
                                        <span>{{personalDetails?.email || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Phone:</label>
                                        <span>{{personalDetails?.phone || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Gender:</label>
                                        <span>{{personalDetails?.gender || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="personalDetails?.profileCreatedOn">
                                        <label>Profile Created:</label>
                                        <span>{{personalDetails?.profileCreatedOn | date:'medium'}}</span>
                                    </div>
                                    <div class="detail-item" *ngIf="personalDetails?.registrationDate">
                                        <label>Registration Date:</label>
                                        <span>{{personalDetails?.registrationDate | date:'medium'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Profile Complete:</label>
                                        <span>{{personalDetails?.profileCompleted || 'N/A'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="details-section">
                                    <h5>Dates Information</h5>
                                    <div class="detail-item">
                                        <label>Planned Dates:</label>
                                        <span>{{info?.totalDatesPlanned || '0'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Completed Dates:</label>
                                        <span>{{info?.totalDatesCompleted || '0'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Cancelled Dates:</label>
                                        <span>{{info?.totalDatesCancelled || '0'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Likes Sent:</label>
                                        <span>{{info?.totalLikesSent || '0'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Likes Received:</label>
                                        <span>{{info?.totalLikesReceived || '0'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Total Matches:</label>
                                        <span>{{info?.totalMatches || '0'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Days to First Match:</label>
                                        <span>{{info?.daysToFirstMatch || '0'}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Dating Information and About Yourself -->
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="details-section">
                                    <h5>Dating Information</h5>
                                    <div class="detail-item">
                                        <label>Date of Birth:</label>
                                        <span>{{formatDateOfBirth(datingInfo?.dateOfBirth)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Nationality:</label>
                                        <span>{{datingInfo?.nationality || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Religion:</label>
                                        <span>{{datingInfo?.religion || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Marital Status:</label>
                                        <span>{{datingInfo?.marital_status || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Child Status:</label>
                                        <span>{{datingInfo?.child_status || 'N/A'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="details-section">
                                    <h5>About Yourself</h5>
                                    <div class="detail-item">
                                        <label>Height:</label>
                                        <span>{{aboutYourself?.height?.[0]?.text || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Alcohol Consumption:</label>
                                        <span>{{formatData(aboutYourself?.alcohol_consumption)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Fitness:</label>
                                        <span>{{formatData(aboutYourself?.fitness)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Hobbies:</label>
                                        <span>{{formatData(aboutYourself?.hobbies)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Wake Up Time:</label>
                                        <span>{{formatData(aboutYourself?.i_usually_wake_up_at)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Interests:</label>
                                        <span>{{formatData(aboutYourself?.interest)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Meet Vibes:</label>
                                        <span>{{formatData(aboutYourself?.meet_vibes)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Personality:</label>
                                        <span>{{formatData(aboutYourself?.personality)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Smoking:</label>
                                        <span>{{aboutYourself?.smoker?.name || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Values:</label>
                                        <span>{{formatData(aboutYourself?.values)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Maxion Goals:</label>
                                        <span>{{formatData(aboutYourself?.you_are_on_maxion_for)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Life Goals:</label>
                                        <span>{{formatData(aboutYourself?.your_life_goals)}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Gender Preference:</label>
                                        <span>{{aboutYourself?.gender_preference || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Connection Pitch:</label>
                                        <span>{{aboutYourself?.connection_pitch || 'N/A'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Occupation:</label>
                                        <span>{{aboutYourself?.occupation || 'N/A'}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Membership Details -->
                        <div class="row mt-4" *ngIf="userSubscription">
                            <div class="col-md-12">
                                <div class="details-section">
                                    <h5>Membership Details (Total Subscriptions:
                                        {{userSubscription?.total_subscriptions}})</h5>
                                    <button type="button" class="btnActive" *ngIf="userSubscription?.isScouted"
                                        style="background-color: #76f16c66; color: #02b708; margin-left: 10px;">Scouted</button>

                                    <div *ngIf="userSubscription?.plan_purchased; else noMembership">
                                        <div class="detail-item">
                                            <label>Membership Type:</label>
                                            <span>{{userSubscription?.plan_purchased}}</span>
                                        </div>
                                        <div class="detail-item" *ngIf="userSubscription?.price">
                                            <label>Membership Status:</label>
                                            <span>{{userSubscription?.price}} {{userSubscription?.currency}}</span>
                                        </div>
                                        <div class="detail-item" *ngIf="userSubscription?.purchase_date">
                                            <label>Start Date:</label>
                                            <span>{{userSubscription?.purchase_date | date:'medium'}}</span>
                                        </div>
                                        <div class="detail-item" *ngIf="userSubscription?.expiry_date">
                                            <label>End Date:</label>
                                            <span>{{userSubscription?.expiry_date | date:'medium'}}</span>
                                        </div>
                                        <div class="detail-item" *ngIf="userSubscription?.hasCancelled !== undefined">
                                            <label>Auto Renewal:</label>
                                            <span>{{userSubscription?.hasCancelled ? 'No' : 'Yes'}}</span>
                                        </div>
                                    </div>
                                    <ng-template #noMembership>
                                        <p>No Active Membership</p>
                                    </ng-template>
                                </div>
                            </div>
                        </div>

                        <!-- ID Verification Details -->
                        <div class="row mt-4" *ngIf="profileStatus">
                            <div class="col-md-12">
                                <div class="details-section">
                                    <h5>ID Verification Details</h5>
                                    <div class="detail-item">
                                        <label>Full Name:</label>
                                        <span>{{profileStatus?.fullName}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Nationality:</label>
                                        <span>{{profileStatus?.nationality}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Date Of Birth:</label>
                                        <span>{{profileStatus?.dateOfBirth | date:'shortDate'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Date of Expiry:</label>
                                        <span>{{profileStatus?.dateOfExpiry | date:'shortDate'}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Status:</label>
                                        <span>{{profileStatus?.status}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Social Details -->
                        <div class="row mt-4" *ngIf="socialDetails">
                            <div class="col-md-12">
                                <div class="details-section">
                                    <h5>Social Details</h5>
                                    <div class="detail-item">
                                        <label>Name:</label>
                                        <span>{{socialDetails?.name}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Email:</label>
                                        <span>{{socialDetails?.email}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>Social Type:</label>
                                        <span>{{socialDetails?.social_type}}</span>
                                    </div>
                                    <div class="detail-item">
                                        <label>URL:</label>
                                        <span>
                                            <a [href]="socialDetails?.url?.startsWith('http://') || socialDetails?.url?.startsWith('https://') ? socialDetails?.url : 'https://' + socialDetails?.url"
                                                target="_blank">{{socialDetails?.url}}</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- User Images -->
                        <div class="row mt-4" *ngIf="userImages && userImages.length > 0">
                            <div class="col-md-12">
                                <div class="details-section">
                                    <h5>User Photos</h5>
                                    <div class="user-images-wrap">
                                        <div class="user-pic-wrap">
                                            <ul>
                                                <li *ngFor="let item of userImages">
                                                    <div class="userimage-upload">
                                                        <img [src]="item?.profile_image" />
                                                    </div>
                                                </li>
                                                <li *ngIf="profileStatus?.selfieImage">
                                                    <div class="userimage-upload">
                                                        <img [src]="profileStatus?.selfieImage" />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>